import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ApprovalFilterForm, WorkOrderFilterForm } from '../../form-model/work-order-filter.form.model';
import { WorkOrderSearchTextForm } from '../../form-model/work-order-search-text.form.model';

import { BulkWorkOrderCompletionBody } from '../../models/bulk-work-order/bulk-work-order-completion.model';
import { ApprovalAllSearchComponent } from '../../components/manual-approval-all-list-wo/approval-all-search/approval-all-search.component';
import { ApprovalAllFiltersComponent } from '../../components/manual-approval-all-list-wo/approval-all-filters/approval-all-filters.component';
import { ApprovalAllWoGridComponent } from '../../components/manual-approval-all-list-wo/approval-all-wo-grid/approval-all-wo-grid.component';
@Component({
  selector: 'app-work-order-list-page',
  imports: [
    ApprovalAllSearchComponent,
    ApprovalAllWoGridComponent,
    ApprovalAllFiltersComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
  ],
  templateUrl: './list-all-processed-work-orders.component.html',
  styleUrl: './list-all-processed-work-orders.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListAllProcessedWorkOrdersComponent {
  filterFormGroup = this.formBuilder.group({
    workOrderFilterForm: this.formBuilder.group<ApprovalFilterForm>({} as ApprovalFilterForm),
    workOrderSearchTextForm: this.formBuilder.group<WorkOrderSearchTextForm>({} as WorkOrderSearchTextForm),
  });
  constructor(private formBuilder: FormBuilder) {}
}
